var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.stylePanel },
    [
      _c(
        "CompassPanel",
        {
          ref: _vm.refPanel,
          attrs: {
            size: "large",
            title: _vm.subject,
            icon: "obj-slsy-sent-email",
            enableShrink: ""
          },
          on: { toggled: _vm.toggleState, closed: _vm.closePanel },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  !_vm.isPanelMinimized && !_vm.isEditing
                    ? _c("div", { staticClass: "email-panel__footer" }, [
                        _c(
                          "div",
                          { staticClass: "compass-panel__footer--default" },
                          [
                            _c(
                              "CompassTooltip",
                              {
                                attrs: {
                                  disabled: _vm.canSendEmail,
                                  content: _vm.$t.__(
                                    "email.EmailPanel.error_reconnect_email_account"
                                  ),
                                  placement: "top"
                                }
                              },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__("common.actions.transfer"),
                                    type: "secondary",
                                    size: "medium",
                                    leftIcon: "forward",
                                    disabled: _vm.loading || !_vm.canSendEmail
                                  },
                                  on: { click: _vm.handleForward }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassTooltip",
                              {
                                attrs: {
                                  disabled: _vm.canSendEmail,
                                  content: _vm.$t.__(
                                    "email.EmailPanel.error_reconnect_email_account"
                                  ),
                                  placement: "top"
                                }
                              },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__(
                                      "email.EmailConsultPanel.reply_all"
                                    ),
                                    type: "secondary",
                                    size: "medium",
                                    leftIcon: "reply-all",
                                    disabled: _vm.loading || !_vm.canSendEmail
                                  },
                                  on: { click: _vm.handleReplyAll }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "CompassTooltip",
                              {
                                attrs: {
                                  disabled: _vm.canSendEmail,
                                  content: _vm.$t.__(
                                    "email.EmailPanel.error_reconnect_email_account"
                                  ),
                                  placement: "top-end"
                                }
                              },
                              [
                                _c("CompassButton", {
                                  attrs: {
                                    label: _vm.$t.__("common.actions.answer"),
                                    type: "secondary",
                                    size: "medium",
                                    leftIcon: "reply",
                                    disabled: _vm.loading || !_vm.canSendEmail
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleReply(_vm.emailInfo)
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.showPanel,
            callback: function($$v) {
              _vm.showPanel = $$v
            },
            expression: "showPanel"
          }
        },
        [
          _c(
            "template",
            { slot: "default" },
            [
              _vm.loading
                ? _c("CompassLoader", {
                    staticClass: "loader",
                    attrs: { size: "large" }
                  })
                : _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isPanelMinimized,
                          expression: "!isPanelMinimized"
                        }
                      ],
                      staticClass: "email-panel__content"
                    },
                    [
                      _vm.error
                        ? _c("CompassAlert", {
                            attrs: {
                              description: _vm.error.description,
                              action: _vm.error.action,
                              showClose: false,
                              type: "error"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.olderThreads, function(item, index) {
                        return _c("EmailConsultPanelItem", {
                          key: item.id,
                          attrs: {
                            email: item,
                            thread: _vm.thread,
                            showContent:
                              _vm.olderThreads.length > 1 &&
                              _vm.showEmailThreadContent(index),
                            unique: false,
                            canSendEmail: _vm.canSendEmail
                          },
                          on: {
                            reply: function($event) {
                              return _vm.handleReply(item)
                            }
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm.isEditing
                        ? _c("EmailConsultPanelEditor", {
                            ref: _vm.refPanelEditor,
                            attrs: {
                              hashPanel: _vm.hashPanel,
                              recipients: _vm.recipients,
                              thread: _vm.thread,
                              threadId: _vm.decodedThreadId,
                              replyContent: _vm.replyContent,
                              replyType: _vm.replyType,
                              forward: _vm.forward,
                              signature: _vm.signature,
                              prefillContent: _vm.description,
                              prefillAttachments: _vm.attachments,
                              sending_type: _vm.sending_type,
                              objectid: _vm.objectid,
                              providerThreadId: _vm.isFromProvider
                                ? _vm.threadId
                                : null,
                              isDraft: _vm.isDraft
                            },
                            on: {
                              handleClose: _vm.closePanel,
                              delete: _vm.handleDelete,
                              change: _vm.handleChange
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.currentAndRecentThreads, function(
                        item,
                        index
                      ) {
                        return _c("EmailConsultPanelItem", {
                          key: item.id,
                          attrs: {
                            email: item,
                            thread: _vm.thread,
                            showContent: _vm.showEmailThreadContent(index),
                            unique: _vm.thread.length === 1,
                            isCurrentEmail: _vm.checkIsCurrentEmail(item),
                            canSendEmail: _vm.canSendEmail
                          },
                          on: {
                            reply: function($event) {
                              return _vm.handleReply(item)
                            }
                          }
                        })
                      })
                    ],
                    2
                  )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }